import { OverlayContainer, PrimaryButton, ReactIcons, SimpleButton } from "@kalyzee/kalyzee-ui";
import { SearchInput } from "@kalyzee/kast-web-sdk/web-components";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { GlassDatePicker } from "../../../../components/utils/GlassDatePicker";
import styles from "./VodFiltersPopup.module.css";

export interface VodFiltersPopupProps {
  visible: boolean;
  onClose: () => void;
  search: string | undefined;
  dateRange: [Date | null, Date | null];
  onApply: (search: string | undefined, dateRange: [Date | null, Date | null]) => void;
}

export const VodFiltersPopup: React.FC<VodFiltersPopupProps> = ({
  visible,
  onClose,
  search,
  dateRange,
  onApply,
}) => {
  const [localSearch, setLocalSearch] = useState<string | undefined>(search);
  const [localDateRange, setLocalDateRange] = useState<[Date | null, Date | null]>(dateRange);

  useEffect(() => {
    if (visible) {
      setLocalSearch(search);
      setLocalDateRange(dateRange);
    }
  }, [visible, search, dateRange]);

  const onReset = () => {
    setLocalSearch(undefined);
    setLocalDateRange([null, null]);
  };

  const onSubmit = () => {
    onApply(localSearch?.trim() || undefined, localDateRange);
  };

  return (
    <OverlayContainer
      visible={visible}
      style={{ position: "fixed", inset: 0, zIndex: 1000, overflow: "visible" }}
      overlayStyle={{ padding: "1em" }}
      onClose={onClose}
      overlay={
        <div className={styles.card} onClick={(e) => e.stopPropagation()}>
          <PrimaryButton className={styles.closeBtn} onClick={onClose}>
            <ReactIcons.Close style={{ height: "0.8em" }} />
          </PrimaryButton>

          <div className={styles.header}>
            <h2 className={styles.title}>Définir les filtres</h2>
            <p className={styles.subtitle}>Affinez la recherche par nom, expert ou date.</p>
          </div>

          <div className={styles.field}>
            <label className={styles.label}>Recherche par nom du cours ou de l'expert</label>
            <SearchInput
              value={localSearch ?? ""}
              setValue={setLocalSearch}
              className={styles.search}
              nativeProps={{
                onKeyDown: (ev) => {
                  if (ev.key === "Enter") onSubmit();
                },
                placeholder: "Jean Dupont, Mathématiques ...",
              }}
            />
          </div>

          <div className={clsx(styles.field, styles.dateField)}>
            <label className={styles.label}>Recherche par date</label>
            <GlassDatePicker
              ready={!!localDateRange[0]}
              selectsRange={true}
              startDate={localDateRange[0] ?? undefined}
              endDate={localDateRange[1] ?? undefined}
              onChange={setLocalDateRange}
              isClearable={true}
              placeholderText="Choisir une période"
            />
          </div>

          <div className={styles.actions}>
            <SimpleButton
              className={clsx(styles.actionBtn, styles.resetBtn)}
              label="Réinitialiser"
              onClick={onReset}
            />
            <SimpleButton
              className={clsx(styles.actionBtn, styles.applyBtn)}
              label="Appliquer"
              onClick={onSubmit}
            />
          </div>
        </div>
      }
    />
  );
};
